import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import classnames from "classnames";

import styles from "./high-frequency-word.module.css";
import * as highFrequencyWordActions from "../../redux/actions/highFrequencyWord";
import { srcPath } from "../../util/Path";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { backToWeb } from "../../util/Util";
import { State } from "../../redux/store";
import IntroBoard from "./IntroBoard";
import { soundAudio } from "../../redux/actions/highFrequencyWord";

const IntroductionPage = () => {
  const dispatch = useDispatch();
  const [imgLoaded, addImgLoaded] = useImgLoaded(7);
  const { grade, unit, webUrl } = useSelector((state: State) => state.shared);
  const { firstClicked } = useSelector(
    (state: State) => state.highFrequencyWord
  );
  const [page, setPage] = useState(1);

  const onBack = () => {
    if (page === 1) {
      backToWeb("small_book", webUrl, grade, unit);
    } else {
      setPage((prev) => prev - 1);
    }
  };

  const onNext = () => {
    if (page === 3) {
      dispatch(highFrequencyWordActions.startGame());
    } else {
      setPage((prev) => prev + 1);
      if (!firstClicked) {
        soundAudio.correct.play();
        soundAudio.wrong.play();
        soundAudio.engineIn.play();
        soundAudio.engineOut.play();
        dispatch(highFrequencyWordActions.firstClick());
      }
    }
  };

  return (
    <div style={{ display: imgLoaded ? "block" : "none" }}>
      <img
        className="bg"
        src={srcPath("high-frequency-word/bg/intro.png")}
        alt=""
        onLoad={addImgLoaded}
      />
      {/* <CSSTransition
        in={imgLoaded}
        timeout={150}
        classNames={{
          enter: styles.introBoardEnter,
          enterActive: styles.introBoardEnterActive,
        }}
      > */}
      <IntroBoard page={page} addImgLoaded={addImgLoaded} />
      {/* </CSSTransition> */}
      <img
        className={classnames("abs", "btn", "main-btn", styles.introBack)}
        src={srcPath("shared/back.png")}
        alt=""
        onLoad={addImgLoaded}
        onClick={onBack}
      />
      <img
        className={classnames("abs", "btn", "main-btn", styles.introNext)}
        src={srcPath("shared/next.png")}
        alt=""
        onLoad={addImgLoaded}
        onClick={onNext}
      />
    </div>
  );
};

export default IntroductionPage;
